export default Object.freeze({
  Equal: 'equal',
  NotEqual: 'not-equal',
  GreaterThan: 'greater-than',
  GreaterThanOrEqual: 'greater-than-or-equal',
  LessThan: 'less-than',
  LessThanOrEqual: 'less-than-or-equal',
  Contains: 'contains',
  NotContains: 'not-contains',
  IsNull: 'is-null',
  IsNotNull: 'is-not-null',
});
